/* eslint-disable */
export default {
  _background_overlay: 'background_overlay',
  _QuestionBg: 'QuestionBg',
  _ScoreBg: 'ScoreBg',
  _PausedBg: 'PausedBg',
  _UI_Header: 'UI_Header',
  _PlatformQuestion: 'PlatformQuestion',
  _InstructArrows_2: 'InstructArrows 2',
  _title_platform: 'title_platform',
  _ExampleTablet: 'ExampleTablet',
  _MiddleLine: 'MiddleLine',
  _Glasses: 'Glasses',
  _BUTTON_quit: 'BUTTON_quit',
  _BUTTON_quitDWN: 'BUTTON_quitDWN',
  _Hats: 'Hats',
  _large_platform: 'large_platform',
  _smoke_puff: 'smoke-puff',
  _filler_spurt_0006: 'filler_spurt_0006',
  _paint_spurt_0006: 'paint_spurt_0006',
  _filler_spurt_0005: 'filler_spurt_0005',
  _medium_platform: 'medium_platform',
  _paint_spurt_0005: 'paint_spurt_0005',
  _crumble_platform: 'crumble_platform',
  _orange_fuzzbug: 'orange_fuzzbug',
  _small_platform: 'small_platform',
  _filler_spurt_0007: 'filler_spurt_0007',
  _question_box: 'question_box',
  _purple_fuzzbug: 'purple_fuzzbug',
  _FuzzbugAnimation_ArmsJump_0015: 'FuzzbugAnimation/ArmsJump_0015',
  _FuzzbugAnimation_ArmsDown_0003: 'FuzzbugAnimation/ArmsDown_0003',
  _FuzzbugAnimation_ArmsJump_0009: 'FuzzbugAnimation/ArmsJump_0009',
  _filler_spurt_0004: 'filler_spurt_0004',
  _paint_spurt_0007: 'paint_spurt_0007',
  _FuzzbugAnimation_ArmsJump_0008: 'FuzzbugAnimation/ArmsJump_0008',
  _FuzzbugAnimation_ArmsUp_0004: 'FuzzbugAnimation/ArmsUp_0004',
  _beaker: 'beaker',
  _FuzzbugAnimation_ArmsJump_0010: 'FuzzbugAnimation/ArmsJump_0010',
  _FuzzbugAnimation_ArmsJump_0011: 'FuzzbugAnimation/ArmsJump_0011',
  _FuzzbugAnimation_ArmsJump_0012: 'FuzzbugAnimation/ArmsJump_0012',
  _FuzzbugAnimation_ArmsJump_0013: 'FuzzbugAnimation/ArmsJump_0013',
  _FuzzbugAnimation_ArmsJump_0014: 'FuzzbugAnimation/ArmsJump_0014',
  _paint_spurt_0004: 'paint_spurt_0004',
  _FuzzbugAnimation_ArmsDown_0001: 'FuzzbugAnimation/ArmsDown_0001',
  _FuzzbugAnimation_ArmsUp_0005: 'FuzzbugAnimation/ArmsUp_0005',
  _filler_spurt_0003: 'filler_spurt_0003',
  _red_fuzzbug: 'red_fuzzbug',
  _thermometer: 'thermometer',
  _white_fuzzbug: 'white_fuzzbug',
  _paint_spurt_0003: 'paint_spurt_0003',
  _yellow_fuzzbug: 'yellow_fuzzbug',
  _FuzzbugAnimation_ArmsHappy_0003: 'FuzzbugAnimation/ArmsHappy_0003',
  _FuzzbugAnimation_ArmsHappy_0005: 'FuzzbugAnimation/ArmsHappy_0005',
  _FuzzbugAnimation_ArmsHappy_0011: 'FuzzbugAnimation/ArmsHappy_0011',
  _FuzzbugAnimation_ArmsHappy_0013: 'FuzzbugAnimation/ArmsHappy_0013',
  _blue_fuzzbug: 'blue_fuzzbug',
  _green_fuzzbug: 'green_fuzzbug',
  _Body_Orange: 'Body_Orange',
  _bodycolor_red: 'bodycolor_red',
  _smoke_puff2: 'smoke-puff2',
  _Arrow_Left: 'Arrow_Left',
  _Arrow_Right: 'Arrow_Right',
  _wrench: 'wrench',
  _filler_spurt_0008: 'filler_spurt_0008',
  _FuzzbugAnimation_ArmsDown_0002: 'FuzzbugAnimation/ArmsDown_0002',
  _smoke_puff3: 'smoke-puff3',
  _filler_spurt_0001: 'filler_spurt_0001',
  _paint_spurt_0001: 'paint_spurt_0001',
  _filler_spurt_0002: 'filler_spurt_0002',
  _paint_spurt_0002: 'paint_spurt_0002',
  _jester_hat: 'jester_hat',
  _bodycolor_blue: 'bodycolor_blue',
  _lightbulb: 'lightbulb',
  _BUTTON_mute: 'BUTTON_mute',
  _BUTTON_volume: 'BUTTON_volume',
  _FuzzbugAnimation_ArmsUp_0007: 'FuzzbugAnimation/ArmsUp_0007',
  _paint_spurt_0008: 'paint_spurt_0008',
  _FuzzbugAnimation_ArmsUp_0006: 'FuzzbugAnimation/ArmsUp_0006',
  _bodycolor_green: 'bodycolor_green',
  _FuzzbugAnimation_ArmsJump_0002: 'FuzzbugAnimation/ArmsJump_0002',
  _bodycolor_orange: 'bodycolor_orange',
  _FuzzbugAnimation_ArmsUp_0001: 'FuzzbugAnimation/ArmsUp_0001',
  _hat_animation_0000: 'hat_animation/0000',
  _FuzzbugAnimation_ArmsJump_0018: 'FuzzbugAnimation/ArmsJump_0018',
  _blue_brush: 'blue_brush',
  _bodycolor_purple: 'bodycolor_purple',
  _bodycolor_yellow: 'bodycolor_yellow',
  _red_brush: 'red_brush',
  _JasonBodyWind_Blow_0000: 'JasonBodyWind/Blow_0000',
  _JasonBodyWind_Blow_0001: 'JasonBodyWind/Blow_0001',
  _JasonBodyWind_Blow_0004: 'JasonBodyWind/Blow_0004',
  _JasonBodyWind_Blow_0005: 'JasonBodyWind/Blow_0005',
  _JasonBodyWind_Blow_0008: 'JasonBodyWind/Blow_0008',
  _JasonBodyWind_Blow_0009: 'JasonBodyWind/Blow_0009',
  _JasonBodyWind_Blow_0002: 'JasonBodyWind/Blow_0002',
  _JasonBodyWind_Blow_0003: 'JasonBodyWind/Blow_0003',
  _JasonBodyWind_Blow_0006: 'JasonBodyWind/Blow_0006',
  _JasonBodyWind_Blow_0007: 'JasonBodyWind/Blow_0007',
  _FuzzbugAnimation_ArmsJump_0005: 'FuzzbugAnimation/ArmsJump_0005',
  _FuzzbugAnimation_ArmsJump_0017: 'FuzzbugAnimation/ArmsJump_0017',
  _FB_arms_6: 'FB_arms+6',
  _gear: 'gear',
  _FuzzbugAnimation_ArmsJump_0003: 'FuzzbugAnimation/ArmsJump_0003',
  _FuzzbugAnimation_ArmsJump_0007: 'FuzzbugAnimation/ArmsJump_0007',
  _InstructArrows: 'InstructArrows',
  _FuzzbugAnimation_ArmsJump_0016: 'FuzzbugAnimation/ArmsJump_0016',
  _FuzzbugAnimation_ArmsJump_0004: 'FuzzbugAnimation/ArmsJump_0004',
  _FuzzbugAnimation_ArmsJump_0006: 'FuzzbugAnimation/ArmsJump_0006',
  _FuzzbugAnimation_ArmsUp_0009: 'FuzzbugAnimation/ArmsUp_0009',
  _FuzzbugAnimation_ArmsUp_0008: 'FuzzbugAnimation/ArmsUp_0008',
  _FuzzbugAnimation_ArmsUp_0003: 'FuzzbugAnimation/ArmsUp_0003',
  _FuzzbugAnimation_ArmsHappy_0004: 'FuzzbugAnimation/ArmsHappy_0004',
  _FuzzbugAnimation_ArmsHappy_0012: 'FuzzbugAnimation/ArmsHappy_0012',
  _glow: 'glow',
  _FuzzbugAnimation_LegsOpen_0010: 'FuzzbugAnimation/LegsOpen_0010',
  _FB_arms_5: 'FB_arms+5',
  _FuzzbugAnimation_ArmsHappy_0002: 'FuzzbugAnimation/ArmsHappy_0002',
  _FuzzbugAnimation_ArmsHappy_0006: 'FuzzbugAnimation/ArmsHappy_0006',
  _FuzzbugAnimation_ArmsHappy_0010: 'FuzzbugAnimation/ArmsHappy_0010',
  _FuzzbugAnimation_ArmsHappy_0014: 'FuzzbugAnimation/ArmsHappy_0014',
  _red_glasses: 'red_glasses',
  _FuzzbugAnimation_ArmsDown_0004: 'FuzzbugAnimation/ArmsDown_0004',
  _FuzzbugAnimation_ArmsDown_0000: 'FuzzbugAnimation/ArmsDown_0000',
  _FuzzbugAnimation_ArmsUp_0010: 'FuzzbugAnimation/ArmsUp_0010',
  _FuzzbugAnimation_ArmsUp_0002: 'FuzzbugAnimation/ArmsUp_0002',
  _AnswerFeedback_Incorrect: 'AnswerFeedback_Incorrect',
  _FuzzbugAnimation_ArmsDown_0005: 'FuzzbugAnimation/ArmsDown_0005',
  _AnswerFeedback_Correct: 'AnswerFeedback_Correct',
  _FB_arms_4: 'FB_arms+4',
  _FuzzbugAnimation_ArmsJump_0019: 'FuzzbugAnimation/ArmsJump_0019',
  _FB_arms_3: 'FB_arms+3',
  _black_glasses: 'black_glasses',
  _FB_legs_1: 'FB_legs+1',
  _orange_brush: 'orange_brush',
  _green_brush: 'green_brush',
  _purple_brush: 'purple_brush',
  _yellow_brush: 'yellow_brush',
  _END_paintbrush: 'END_paintbrush',
  _BUTTON_menu: 'BUTTON_menu',
  _FuzzbugAnimation_ArmsJump_0001: 'FuzzbugAnimation/ArmsJump_0001',
  _FB_arms_2: 'FB_arms+2',
  _abit: 'abit',
  _FuzzbugAnimation_ArmsHappy_0001: 'FuzzbugAnimation/ArmsHappy_0001',
  _FuzzbugAnimation_ArmsHappy_0007: 'FuzzbugAnimation/ArmsHappy_0007',
  _FuzzbugAnimation_ArmsHappy_0009: 'FuzzbugAnimation/ArmsHappy_0009',
  _FuzzbugAnimation_ArmsHappy_0015: 'FuzzbugAnimation/ArmsHappy_0015',
  _FuzzbugAnimation_ArmsDown_0006: 'FuzzbugAnimation/ArmsDown_0006',
  _FuzzbugAnimation_ArmsHappy_0000: 'FuzzbugAnimation/ArmsHappy_0000',
  _FuzzbugAnimation_ArmsHappy_0008: 'FuzzbugAnimation/ArmsHappy_0008',
  _FuzzbugAnimation_ArmsHappy_0016: 'FuzzbugAnimation/ArmsHappy_0016',
  _FuzzbugAnimation_ArmsJump_0000: 'FuzzbugAnimation/ArmsJump_0000',
  _FuzzbugAnimation_ArmsJump_0020: 'FuzzbugAnimation/ArmsJump_0020',
  _FuzzbugAnimation_ArmsSad_0000: 'FuzzbugAnimation/ArmsSad_0000',
  _FuzzbugAnimation_ArmsSad_0012: 'FuzzbugAnimation/ArmsSad_0012',
  _FuzzbugAnimation_ArmsUp_0000: 'FuzzbugAnimation/ArmsUp_0000',
  _FuzzbugAnimation_ArmsSad_0001: 'FuzzbugAnimation/ArmsSad_0001',
  _FuzzbugAnimation_ArmsSad_0011: 'FuzzbugAnimation/ArmsSad_0011',
  _FuzzbugAnimation_ArmsSad_0002: 'FuzzbugAnimation/ArmsSad_0002',
  _FB_arms_1: 'FB_arms+1',
  _party_hat: 'party_hat',
  _FuzzbugAnimation_ArmsSad_0003: 'FuzzbugAnimation/ArmsSad_0003',
  _FuzzbugAnimation_ArmsSad_0004: 'FuzzbugAnimation/ArmsSad_0004',
  _piece_5: 'piece+5',
  _piece_11: 'piece+11',
  _FuzzbugAnimation_LegsOpen_0005: 'FuzzbugAnimation/LegsOpen_0005',
  _pinwheel_hat: 'pinwheel_hat',
  _FuzzbugAnimation_ArmsSad_0010: 'FuzzbugAnimation/ArmsSad_0010',
  _hat_animation_0001: 'hat_animation/0001',
  _FuzzbugAnimation_ArmsSad_0005: 'FuzzbugAnimation/ArmsSad_0005',
  _FuzzbugAnimation_ArmsSad_0009: 'FuzzbugAnimation/ArmsSad_0009',
  _hat_animation_0002: 'hat_animation/0002',
  _FuzzbugAnimation_ArmsSad_0006: 'FuzzbugAnimation/ArmsSad_0006',
  _purple_glasses: 'purple_glasses',
  _FuzzbugAnimation_LegsClose_0001: 'FuzzbugAnimation/LegsClose_0001',
  _FB_legs_4: 'FB_legs+4',
  _FuzzbugAnimation_LegsClose_0005: 'FuzzbugAnimation/LegsClose_0005',
  _FuzzbugAnimation_EyesShut_0000: 'FuzzbugAnimation/EyesShut_0000',
  _piece_6: 'piece+6',
  _FuzzbugAnimation_LegsClose_0002: 'FuzzbugAnimation/LegsClose_0002',
  _FuzzbugAnimation_LegsHappy_0001: 'FuzzbugAnimation/LegsHappy_0001',
  _FuzzbugAnimation_LegsHappy_0007: 'FuzzbugAnimation/LegsHappy_0007',
  _FuzzbugAnimation_LegsHappy_0009: 'FuzzbugAnimation/LegsHappy_0009',
  _FuzzbugAnimation_LegsHappy_0015: 'FuzzbugAnimation/LegsHappy_0015',
  _FuzzbugAnimation_LegsClose_0000: 'FuzzbugAnimation/LegsClose_0000',
  _hat_animation_0003: 'hat_animation/0003',
  _hat_animation_0004: 'hat_animation/0004',
  _hat_animation_0005: 'hat_animation/0005',
  _FuzzbugAnimation_LegsOpen_0002: 'FuzzbugAnimation/LegsOpen_0002',
  _FB_eyes_1: 'FB_eyes+1',
  _FB_eyes_2: 'FB_eyes+2',
  _FuzzbugAnimation_LegsOpen_0001: 'FuzzbugAnimation/LegsOpen_0001',
  _FB_legs_2: 'FB_legs+2',
  _FuzzbugAnimation_LegsClose_0006: 'FuzzbugAnimation/LegsClose_0006',
  _FuzzbugAnimation_LegsClose_0007: 'FuzzbugAnimation/LegsClose_0007',
  _FuzzbugAnimation_LegsHappy_0000: 'FuzzbugAnimation/LegsHappy_0000',
  _FuzzbugAnimation_LegsHappy_0008: 'FuzzbugAnimation/LegsHappy_0008',
  _FuzzbugAnimation_LegsHappy_0016: 'FuzzbugAnimation/LegsHappy_0016',
  _FuzzbugAnimation_LegsOpen_0000: 'FuzzbugAnimation/LegsOpen_0000',
  _FuzzbugAnimation_LegsSad_0000: 'FuzzbugAnimation/LegsSad_0000',
  _FuzzbugAnimation_LegsSad_0001: 'FuzzbugAnimation/LegsSad_0001',
  _FuzzbugAnimation_LegsSad_0002: 'FuzzbugAnimation/LegsSad_0002',
  _FuzzbugAnimation_LegsSad_0003: 'FuzzbugAnimation/LegsSad_0003',
  _FuzzbugAnimation_LegsSad_0004: 'FuzzbugAnimation/LegsSad_0004',
  _FuzzbugAnimation_LegsSad_0005: 'FuzzbugAnimation/LegsSad_0005',
  _FuzzbugAnimation_LegsSad_0006: 'FuzzbugAnimation/LegsSad_0006',
  _FuzzbugAnimation_LegsSad_0007: 'FuzzbugAnimation/LegsSad_0007',
  _FuzzbugAnimation_LegsSad_0008: 'FuzzbugAnimation/LegsSad_0008',
  _FuzzbugAnimation_LegsSad_0009: 'FuzzbugAnimation/LegsSad_0009',
  _FuzzbugAnimation_LegsSad_0010: 'FuzzbugAnimation/LegsSad_0010',
  _FuzzbugAnimation_LegsSad_0011: 'FuzzbugAnimation/LegsSad_0011',
  _FuzzbugAnimation_LegsSad_0012: 'FuzzbugAnimation/LegsSad_0012',
  _hat_animation_0006: 'hat_animation/0006',
  _FuzzbugAnimation_ArmsSad_0008: 'FuzzbugAnimation/ArmsSad_0008',
  _FuzzbugAnimation_ArmsSad_0007: 'FuzzbugAnimation/ArmsSad_0007',
  _FuzzbugAnimation_LegsHappy_0004: 'FuzzbugAnimation/LegsHappy_0004',
  _FuzzbugAnimation_LegsHappy_0012: 'FuzzbugAnimation/LegsHappy_0012',
  _hat_animation_0007: 'hat_animation/0007',
  _hat_animation_0008: 'hat_animation/0008',
  _FuzzbugAnimation_LegsOpen_0009: 'FuzzbugAnimation/LegsOpen_0009',
  _piece_4: 'piece+4',
  _paint_spatter_3: 'paint_spatter+3',
  _paint_spatter_orange_3: 'paint_spatter_orange+3',
  _FuzzbugAnimation_MouthFrown_0000: 'FuzzbugAnimation/MouthFrown_0000',
  _FuzzbugAnimation_MouthSmile_0000: 'FuzzbugAnimation/MouthSmile_0000',
  _piece_1: 'piece+1',
  _Feet_Together: 'Feet_Together',
  _FuzzbugAnimation_EyesOpen_0000: 'FuzzbugAnimation/EyesOpen_0000',
  _piece_8: 'piece+8',
  _piece_7: 'piece+7',
  _piece_3: 'piece+3',
  _piece_9: 'piece+9',
  _bit: 'bit',
  _paint_spatter_1: 'paint_spatter+1',
  _paint_spatter_orange_1: 'paint_spatter_orange+1',
  _FuzzbugAnimation_LegsOpen_0007: 'FuzzbugAnimation/LegsOpen_0007',
  _FuzzbugAnimation_LegsOpen_0008: 'FuzzbugAnimation/LegsOpen_0008',
  _FuzzbugAnimation_LegsOpen_0006: 'FuzzbugAnimation/LegsOpen_0006',
  _FuzzbugAnimation_LegsClose_0003: 'FuzzbugAnimation/LegsClose_0003',
  _FuzzbugAnimation_LegsHappy_0003: 'FuzzbugAnimation/LegsHappy_0003',
  _FuzzbugAnimation_LegsHappy_0005: 'FuzzbugAnimation/LegsHappy_0005',
  _FuzzbugAnimation_LegsHappy_0011: 'FuzzbugAnimation/LegsHappy_0011',
  _FuzzbugAnimation_LegsHappy_0013: 'FuzzbugAnimation/LegsHappy_0013',
  _FuzzbugAnimation_LegsOpen_0004: 'FuzzbugAnimation/LegsOpen_0004',
  _FB_legs_3: 'FB_legs+3',
  _piece_2: 'piece+2',
  _piece_10: 'piece+10',
  _FuzzbugAnimation_LegsClose_0004: 'FuzzbugAnimation/LegsClose_0004',
  _FuzzbugAnimation_LegsHappy_0002: 'FuzzbugAnimation/LegsHappy_0002',
  _FuzzbugAnimation_LegsHappy_0006: 'FuzzbugAnimation/LegsHappy_0006',
  _FuzzbugAnimation_LegsHappy_0010: 'FuzzbugAnimation/LegsHappy_0010',
  _FuzzbugAnimation_LegsHappy_0014: 'FuzzbugAnimation/LegsHappy_0014',
  _FuzzbugAnimation_LegsOpen_0003: 'FuzzbugAnimation/LegsOpen_0003',
  _paint_spatter_2: 'paint_spatter+2',
  _paint_spatter_orange_2: 'paint_spatter_orange+2',
  _confetti_5: 'confetti+5',
  _confetti_6: 'confetti+6',
  _FuzzbugAnimation_MouthOpen_0000: 'FuzzbugAnimation/MouthOpen_0000',
  _confetti_1: 'confetti+1',
  _confetti_2: 'confetti+2',
  _confetti_3: 'confetti+3',
  _confetti_4: 'confetti+4',
  _d1: 'd1',
  _d2: 'd2',
  _d3: 'd3',
  _d4: 'd4',
  _d5: 'd5',
  _bg: 'bg',
  _shades_overlay_dot: 'shades_overlay_dot',
}